import React, { ComponentType, useEffect, useState } from 'react'
import { IoLogoWhatsapp } from 'react-icons/io'

interface Props {
  whatsapp: string
  shareUrl: string
  beforeOnShareClick: () => Promise<void>
  hideLabel?: boolean
}

const generateTcw = () => {
  return `${Math.floor(Math.random() * 1000000000000)}`
}

const openWhatsappShare = (whatsapp: string, shareUrl:string) => {
  const cleanPhoneNumber = whatsapp.replace(/ /gi, '')
  const completePropertyUrl = `${shareUrl}?c=${generateTcw()}wa`
  const whatsappUrl = `https://api.whatsapp.com/send/?phone=521${cleanPhoneNumber}&text=Hola quisiera que se comuniquen por este inmueble que vi en Yucatán Premier ${encodeURI(completePropertyUrl)}`
  window.open(whatsappUrl, '__blank')
}

export const Whats: ComponentType<Props> = ({ whatsapp, hideLabel, shareUrl, beforeOnShareClick }) => {

  const onContactClick = (whatsapp: string, shareUrl:string) => {
    beforeOnShareClick()
    openWhatsappShare(whatsapp, shareUrl)
  }

  return (
    <a
      onClick={() => (onContactClick(whatsapp, shareUrl))}
      title="Contactar por WhatsApp"
      className="text-malachite font-weight-500"
    >
      <IoLogoWhatsapp /> {hideLabel ? '' : 'Contactar por WhatsApp'}
    </a>
  )
}
